<template lang="pug">
    
div( :class="$style.root" )
    div( 
        :class="$style.area"
        @click="toggle"
     )
    div( :class="$style.label" ) К оплате
    div(
        :class="$style.amount"
        @click="toggle"
    )
        p( :class="$style.value" ) {{ displayAmount }}
        IconBase(
            :class="[$style.currency]"
            :color="'inherit'"
            :name="'icon-currency-som'"
        )
        div( :class="$style.arrow" )
            IconBase(
                :class="[$style.chevron, isShow && $style.active]"
                :name="'icon-chevron-up_outline'"
                :color="'foreground400'"
                :size="20"
            )
    AnimatedHeightTransition
        div(
            :class="$style.list"
            v-if="isShow"
        )
            div( :class="$style.wrapper" )
                AmountCell(
                    v-for="(cell, index) in products"
                    :class="$style.cell"
                    :key="index"
                    :name="cell.name"
                    :value="cell.value"
                )
        
</template>

<script lang="ts">
import Vue, { computed, ref } from 'vue'

import { IconBase } from '@/shared/ui/IconBase'
import { AnimatedHeightTransition } from '@/shared/ui/transitions/AnimatedHeightTransition'
import { toMoneyString } from '@/shared/lib/utils/default/toMoneyString'

import AmountCell from './AmountCell.vue'
import { useAutoHeight } from './useAutoHeight'

export default Vue.extend({
    name: 'Amount',
    components: { AnimatedHeightTransition, IconBase, AmountCell },
    props: {
        amount: {
            type: String,
            required: true,
        },
        products: {
            type: Array,
            required: true,
        },
    },
    setup(props) {
        const isShow = ref(false)
        const hooks = useAutoHeight()

        const displayAmount = computed(() => {
            return toMoneyString({
                value: props.amount,
            })
        })

        function toggle() {
            isShow.value = !isShow.value
        }

        return {
            displayAmount,
            isShow,
            toggle,
            ...hooks,
        }
    },
})
</script>

<style module lang="scss" src="./Amount.module.scss" />
